import { useEffect, useState } from 'react';

/**
 * Tracks how long an empty query snapshot has persisted so callers can stop
 * polling after `windowMs` without hitting the endpoint forever.
 * `resetKey` (e.g. runId) restarts the window even when the snapshot stays empty.
 */
export const useEmptyPollWindowAge = (
  isEmpty: boolean,
  windowMs: number,
  resetKey?: string,
): number => {
  const [ageMs, setAgeMs] = useState(0);

  useEffect(() => {
    setAgeMs(0);

    if (!isEmpty) {
      return;
    }

    const startedAt = Date.now();
    const timeoutId = window.setTimeout(() => {
      setAgeMs(Date.now() - startedAt);
    }, windowMs);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isEmpty, windowMs, resetKey]);

  return ageMs;
};
